module.exports = "/assets/0b5c162128acac7ae74e29c6455aad96.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2J.png
// module id = 985
// module chunks = 0